import { UserStatus } from '../../graphql/generated/types';

export const userStatusLabels = {
  [UserStatus.Registered]: 'Cadastrado',
  [UserStatus.Approved]: 'Aprovado',
  [UserStatus.Rejected]: 'Recusado',
  [UserStatus.Active]: 'Ativo',
};
